import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { appGlobalDataSelectedCriteriaSelector, appGlobalDataSelectedDateSelector, appGlobalDataSelectedNewsGroupSelector, } from '../store/appGlobalData/appGlobalDataSelectors';
import updateSelectedCriteria from '../store/appGlobalData/actions/updateSelectedCriteria';
import updateSelectedNewsGroup from '../store/appGlobalData/actions/updateSelectedNewsGroup';
/**
 * A custom hook that returns the data necessary to determine
 * the state of the filter buttons, along with the callback functions used by the filter buttons.
 * To be used in combination with the FilterButtons component.
 *
 * @return [
 *  selectedCriteria: The currently selected criteria
 *  selectedNewsGroup: The currently selected news group
 *  resetSearchCriteria: Resets the search criteria to null
 *  onSelectedNewsGroupChange: Toggles the selected news group value
 * ]
 */
var useAppGlobalData = function () {
    var selectedCriteria = useSelector(appGlobalDataSelectedCriteriaSelector);
    var selectedNewsGroup = useSelector(appGlobalDataSelectedNewsGroupSelector);
    var selectedDate = useSelector(appGlobalDataSelectedDateSelector);
    var dispatch = useDispatch();
    var resetSearchCriteria = useCallback(function () {
        dispatch(updateSelectedCriteria(null));
    }, [dispatch, updateSelectedCriteria]);
    var onSelectedNewsGroupChange = useCallback(function (newSelectedGroup) {
        dispatch(updateSelectedNewsGroup(newSelectedGroup));
    }, [dispatch, updateSelectedNewsGroup]);
    return { selectedCriteria: selectedCriteria, selectedNewsGroup: selectedNewsGroup, selectedDate: selectedDate, resetSearchCriteria: resetSearchCriteria, onSelectedNewsGroupChange: onSelectedNewsGroupChange };
};
export default useAppGlobalData;
